var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTicket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80469 2.19535C5.54469 2.45535 5.55869 2.87602 5.71269 3.21069C5.87355 3.56085 5.92333 3.95188 5.85533 4.33118C5.78734 4.71048 5.60483 5.05986 5.33235 5.33235C5.05986 5.60483 4.71048 5.78734 4.33118 5.85533C3.95188 5.92333 3.56085 5.87355 3.21069 5.71269C2.87602 5.55935 2.45535 5.54469 2.19535 5.80469L1.80469 6.19535C1.67971 6.32037 1.6095 6.48991 1.6095 6.66669C1.6095 6.84346 1.67971 7.013 1.80469 7.13802L8.86202 14.1954C8.98704 14.3203 9.15658 14.3905 9.33335 14.3905C9.51013 14.3905 9.67967 14.3203 9.80469 14.1954L10.1954 13.8047C10.4554 13.5447 10.4414 13.124 10.2874 12.7894C10.1265 12.4392 10.0767 12.0482 10.1447 11.6689C10.2127 11.2896 10.3952 10.9402 10.6677 10.6677C10.9402 10.3952 11.2896 10.2127 11.6689 10.1447C12.0482 10.0767 12.4392 10.1265 12.7894 10.2874C13.124 10.4407 13.5447 10.4554 13.8047 10.1954L14.1954 9.80469C14.3203 9.67967 14.3905 9.51013 14.3905 9.33335C14.3905 9.15658 14.3203 8.98704 14.1954 8.86202L7.13802 1.80469C7.013 1.67971 6.84346 1.6095 6.66669 1.6095C6.48991 1.6095 6.32037 1.67971 6.19535 1.80469L5.80469 2.19535V2.19535Z",
    stroke: "#001D9A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/Ticket.02e0631c18ab59126242d146dab98247.svg";
export { ForwardRef as ReactComponent };